// require('./angular-nvd3/angular-nvd3.js');
// require('./nvd3-v1.1.15-beta/nv.d3.js');

// require('./angular-nvd3/angular-nvd3.js');
// require('./nvd3-v1.8.6/nv.d3.js');

require('./angular-nvd3/angular-nvd3.js');
require('../../../../node_modules/nvd3/build/nv.d3.js');

module.exports = "nvd3";
